import * as React from 'react'
import { Query, QueryResult } from 'react-apollo'

import Loader from 'main/components/common/Loader'
import { Modal } from 'main/ui'
import { IRankingFactorWeights } from 'main/util/search'
import Content from './Content'
import { SEARCH_RANKING_FACTOR_WEIGHTS_QUERY } from './gql'

interface IProps {
  rankingWeights: IRankingFactorWeights | null
  onChangeRankingWeights: (searchRankingWeights: IRankingFactorWeights) => void
  onRequestClose: () => void
}

export default function RankingWeightsModal(props: IProps) {
  const { rankingWeights, onChangeRankingWeights, onRequestClose } = props

  return (
    <Query query={SEARCH_RANKING_FACTOR_WEIGHTS_QUERY}>
      {(result: QueryResult) => {
        const { data, error, loading } = result
        if (loading || error || !data || !data.searchRankingFactorWeights) {
          return (
            <Modal title="Search RankingWeights" onRequestClose={onRequestClose}>
              <Loader />
            </Modal>
          )
        }

        return (
          <Modal title="Search Ranking Weights" onRequestClose={onRequestClose}>
            <Content
              defaultRankingWeights={data.searchRankingFactorWeights}
              rankingWeights={rankingWeights ? rankingWeights : data.searchRankingFactorWeights}
              onRequestClose={onRequestClose}
              onChangeRankingWeights={onChangeRankingWeights}
            />
          </Modal>
        )
      }}
    </Query>
  )
}
